import React, { useEffect, useState } from "react";
import { Nav, TabContainer, TabContent, TabPane } from "react-bootstrap";

const BaseTabContainer = ({
  tabs,
  defaultActiveKey = "",
  extraActionOnTabChange = () => { },
  renderTabsRight,
  tabContainerClassName = "",
  tabNavClassName = "",
}) => {
  const [activeTab, setActiveTab] = useState();

  useEffect(() => {
    setActiveTab(defaultActiveKey);
  }, [defaultActiveKey]);

  return <TabContainer
    activeKey={activeTab || tabs[0]?.name}
    className={`${tabContainerClassName || ''}`}
    onSelect={(key) => {
      setActiveTab(key)
      extraActionOnTabChange(key);
    }}
  >
    <Nav className={`nav nav-tabs ${tabNavClassName || ""}`}>
      {tabs.map((tab) => (
        <Nav.Link key={tab.name} className="nav-item" eventKey={tab.name}>
          {tab.name}
        </Nav.Link>
      ))}
      {renderTabsRight && renderTabsRight()}
    </Nav>
    <TabContent>
      {tabs.map((tab, index) => (
        <TabPane eventKey={tab.name} key={index}>
          {tab.content}
        </TabPane>
      ))}
    </TabContent>
  </TabContainer>
}

export default BaseTabContainer;